import { Flex, MantineSpacing, Skeleton } from '@mantine/core';

interface Props {
	count: number;
	rowHeight?: number;
	mih?: number;
	p?: MantineSpacing;
}

export const CardBodySkeleton = ({ count, rowHeight = 20, mih, p = '0.5rem' }: Props) => (
	<Flex direction="column" gap="0.5rem" p={p} mih={mih}>
		{Array.from({ length: count }).map((_, index) => (
			<Skeleton key={index} height={rowHeight} radius="sm" />
		))}
	</Flex>
);
